import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Link,
  Stack,
  Chip,
  Avatar,
  Divider,
  Card,
  CardContent,
  LinearProgress,
  useTheme,
} from "@mui/material";
import { keyframes } from "@mui/material/styles";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Groups2RoundedIcon from "@mui/icons-material/Groups2Rounded";
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import SpeedRoundedIcon from "@mui/icons-material/SpeedRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import Logo from "../assets/ZakazujMeLogo4.png";
import QrAppStore from "../assets/qr-appstore.png";
import QrGooglePlay from "../assets/qr-googleplay.png";
//import MobileAppPromo from "./MobileApp";

export default function About() {
  const theme = useTheme();
  const slide = keyframes`
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  `;

  return (
    <Grid container sx={{ minHeight: "100vh", overflowX: "hidden" }}>
      <Grid
        item
        xs={12}
        sx={{
          position: "relative",
          background:
            theme.palette.mode === "dark"
              ? "radial-gradient(1200px 800px at 20% 30%, #1e2a78 0%, #0b0f2b 50%, #0a0d20 100%)"
              : "radial-gradient(1200px 800px at 20% 30%, #1e2a78 0%, #0b0f2b 50%, #0a0d20 100%)",
          py: { xs: 10, md: 14 },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(600px 380px at 45% 40%, rgba(26,86,219,0.65), transparent 60%), radial-gradient(620px 420px at 65% 60%, rgba(168,85,247,0.55), transparent 62%), radial-gradient(580px 360px at 75% 30%, rgba(6,182,212,0.5), transparent 62%)",
            filter: "blur(18px)",
            opacity: 0.9,
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: { xs: "static", md: "fixed" },
            top: { md: 18 },
            right: { md: 24 },
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "center", md: "flex-end" },
            gap: { xs: 1, sm: 1.5, md: 2 },
            px: { xs: 2, sm: 3, md: 0 },
            py: { xs: 1, md: 0 },
            mt: { xs: 2, md: 0 },
            borderRadius: { xs: 2, md: 0 },
            background: {
              xs: "rgba(10, 13, 32, 0.6)",
              md: "transparent",
            },
            color: "rgba(255,255,255,0.95)",
            zIndex: 1100,
          }}
        >
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/home"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Početna
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/cooperation"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Saradnja
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/about"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            O nama
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/privacy-policy"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Politika privatnosti
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/login"
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 25,
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Prijavi se
          </Link>
          <Link
            hidden
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/userregistration"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              background: "linear-gradient(90deg, #3B82F6 0%, #06B6D4 100%)",
              color: "white",
              boxShadow: "0 2px 8px rgba(59,130,246,0.25)",
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "linear-gradient(90deg, #1D4ED8 0%, #06B6D4 100%)",
                color: "#fff",
              },
            }}
          >
            Registruj se
          </Link>
        </Box>

        <Box
          sx={{
            position: "relative",
            maxWidth: 1200,
            mx: "auto",
            px: { xs: 3, sm: 5 },
            color: "white",
          }}
        >
          <Box
            component="img"
            src={Logo}
            alt="ZakaziMe"
            sx={{
              height: { xs: 90, sm: 120, md: 140 },
              objectFit: "contain",
              filter: "drop-shadow(0 0 18px rgba(124,58,237,0.5))",
              mb: 2,
            }}
          />
          <Typography variant="h2" sx={{ fontWeight: 900, lineHeight: 1.05 }}>
            O Zakazuj platformi
          </Typography>
          <Typography
            variant="h6"
            sx={{ mt: 1.5, maxWidth: 820, color: "rgba(255,255,255,0.85)" }}
          >
            Mi smo tim koji spaja tehnologiju i usluge kako bi zakazivanje bilo
            brzo, pregledno i dostupno svima. Naš cilj je da klijenti lako
            pronađu slobodan termin, a biznisi precizno upravljaju rasporedom,
            bez poziva i čekanja.
          </Typography>
          <Box
            sx={{
              mt: 3,
              display: "inline-flex",
              alignItems: "center",
              gap: 1.5,
              px: 2.5,
              py: 1.2,
              borderRadius: 999,
              background:
                "linear-gradient(90deg, rgba(59,130,246,0.25) 0%, rgba(6,182,212,0.25) 100%)",
              border: "1px solid rgba(255,255,255,0.25)",
              boxShadow: "0 6px 18px rgba(59,130,246,0.25)",
            }}
          >
            <Typography sx={{ fontWeight: 800 }}>
              Saradnja i partnerstva
            </Typography>
            <Divider
              flexItem
              orientation="vertical"
              sx={{ borderColor: "rgba(255,255,255,0.35)" }}
            />
            <Link
              href="mailto:system@zakazuj.com"
              underline="none"
              sx={{ color: "white", fontWeight: 800 }}
            >
              system@zakazuj.com
            </Link>
          </Box>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.02) 100%)",
          py: { xs: 5, md: 7 },
        }}
      >
        <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2.5, sm: 5 } }}>
          <Grid container spacing={3}>
            {[
              {
                icon: <SpeedRoundedIcon />,
                title: "Jednostavno zakazivanje",
                desc: "Klijenti rezervišu termin online, bez telefonskih poziva.",
              },
              {
                icon: <ShieldRoundedIcon />,
                title: "Bezbednost podataka",
                desc: "Podaci o klijentima i terminima su sigurni i organizovani.",
              },
              {
                icon: <AutoFixHighRoundedIcon />,
                title: "Fleksibilnost",
                desc: "Radi za salone, servise, ordinacije, treninge i timove.",
              },
              {
                icon: <SupportAgentRoundedIcon />,
                title: "Podrška",
                desc: "Tu smo da pomognemo tokom postavljanja i rada.",
              },
            ].map((f, i) => (
              <Grid key={i} item xs={12} md={6} lg={3}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: "100%",
                    borderRadius: 3,
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "white",
                    backdropFilter: "blur(8px)",
                  }}
                >
                  <Chip
                    icon={f.icon}
                    label={f.title}
                    sx={{
                      bgcolor: "rgba(59,130,246,0.18)",
                      color: "#DDEAFE",
                      border: "1px solid rgba(59,130,246,0.35)",
                      mb: 1.5,
                    }}
                  />
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    {f.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={4}>
              <Card
                elevation={0}
                sx={{
                  p: 3,
                  height: "100%",
                  borderRadius: 3,
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "white",
                  backdropFilter: "blur(8px)",
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Typography variant="overline" sx={{ opacity: 0.8 }}>
                    Za klijente
                  </Typography>
                  <Typography variant="h4" sx={{ fontWeight: 900 }}>
                    Brzo i jasno
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, opacity: 0.9 }}>
                    Izaberite uslugu, slobodan termin i potvrdite rezervaciju.
                    Dobićete potvrdu i podsetnik pre termina.
                  </Typography>
                  <Box sx={{ mt: 2 }}>
                    <LinearProgress value={90} variant="determinate" />
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card
                elevation={0}
                sx={{
                  p: 3,
                  height: "100%",
                  borderRadius: 3,
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "white",
                  backdropFilter: "blur(8px)",
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Typography variant="overline" sx={{ opacity: 0.8 }}>
                    Za biznise
                  </Typography>
                  <Typography variant="h4" sx={{ fontWeight: 900 }}>
                    Kontrola rasporeda
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, opacity: 0.9 }}>
                    Kreirajte usluge, definišite radno vreme, resurse i
                    zaposlene. Sve izmene su vidljive klijentima u realnom
                    vremenu.
                  </Typography>
                  <Stack direction="row" spacing={1.5} sx={{ mt: 2 }}>
                    {["Salon", "Servis", "Studio", "Tim"].map((n) => (
                      <Avatar
                        key={n}
                        sx={{
                          width: 36,
                          height: 36,
                          bgcolor: "rgba(255,255,255,0.12)",
                          border: "1px solid rgba(255,255,255,0.25)",
                          fontSize: 14,
                        }}
                      >
                        {n[0]}
                      </Avatar>
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card
                elevation={0}
                sx={{
                  p: 3,
                  height: "100%",
                  borderRadius: 3,
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "white",
                  backdropFilter: "blur(8px)",
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Typography variant="overline" sx={{ opacity: 0.8 }}>
                    Prijava i registracija
                  </Typography>
                  <Stack spacing={1.2} sx={{ mt: 1 }}>
                    {[
                      "Registracija ide preko linka ili QR koda radnje/klijenta",
                      "Kreirajte nalog sa email adresom ili brojem telefona",
                      "Potvrdite nalog i popunite osnovne podatke",
                      "Biznis profili dodaju usluge, cene i radno vreme",
                      "Klijenti odmah mogu da rezervišu termin",
                    ].map((t) => (
                      <Stack
                        key={t}
                        direction="row"
                        spacing={1}
                        alignItems="center"
                      >
                        <CheckCircleRoundedIcon fontSize="small" />
                        <Typography variant="body2">{t}</Typography>
                      </Stack>
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Paper
            elevation={0}
            sx={{
              mt: 4,
              p: { xs: 2.5, sm: 3 },
              borderRadius: 3,
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "white",
              backdropFilter: "blur(8px)",
            }}
          >
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={3}
              alignItems={{ xs: "flex-start", md: "center" }}
              justifyContent="space-between"
            >
              <Stack spacing={1}>
                <Typography variant="h5" sx={{ fontWeight: 800 }}>
                  Kako funkcioniše
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Aplikacija spaja klijente i biznise na jednom mestu. Klijent
                  bira uslugu i termin, a biznis dobija jasan pregled svih
                  zakazivanja i može lako da menja raspored.
                </Typography>
              </Stack>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                divider={
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ borderColor: "rgba(255,255,255,0.18)" }}
                  />
                }
              >
                <Chip icon={<Groups2RoundedIcon />} label="Registracija" />
                <Chip icon={<AutoFixHighRoundedIcon />} label="Podešavanja" />
                <Chip icon={<ShieldRoundedIcon />} label="Zakazivanje" />
                <Chip icon={<SpeedRoundedIcon />} label="Obaveštenja" />
              </Stack>
            </Stack>
          </Paper>

          <Paper
            elevation={0}
            sx={{
              mt: 4,
              p: { xs: 2.5, sm: 3 },
              borderRadius: 3,
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "white",
              backdropFilter: "blur(8px)",
              overflow: "hidden",
            }}
          >
            <Stack spacing={1.5}>
              <Typography variant="h5" sx={{ fontWeight: 800 }}>
                Proces zakazivanja, korak po korak
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Sve počinje skeniranjem QR koda ili klikom na link koji dobijate
                od radnje/klijenta. Od tog trenutka, vodi vas jasan i brz tok
                zakazivanja.
              </Typography>
              <Box
                sx={{
                  position: "relative",
                  mt: 1,
                  overflow: "hidden",
                  borderRadius: 2,
                  border: "1px solid rgba(255,255,255,0.12)",
                  background: "rgba(3,7,18,0.35)",
                }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    px: 2,
                    py: 1.5,
                    width: "max-content",
                    animation: `${slide} 18s linear infinite`,
                  }}
                >
                  {[
                    "Skeniraj QR ili otvori link",
                    "Registruj se ili prijavi",
                    "Izaberi uslugu",
                    "Odaberi termin",
                    "Potvrdi rezervaciju",
                    "Dobij podsetnik",
                    "Dođi na termin",
                    "Skeniraj QR ili otvori link",
                    "Registruj se ili prijavi",
                    "Izaberi uslugu",
                    "Odaberi termin",
                    "Potvrdi rezervaciju",
                    "Dobij podsetnik",
                    "Dođi na termin",
                  ].map((step, idx) => (
                    <Chip
                      key={`${step}-${idx}`}
                      label={step}
                      sx={{
                        bgcolor: "rgba(59,130,246,0.18)",
                        color: "#DDEAFE",
                        border: "1px solid rgba(59,130,246,0.35)",
                        fontWeight: 600,
                      }}
                    />
                  ))}
                </Stack>
              </Box>
            </Stack>
          </Paper>

          <Paper
            elevation={0}
            sx={{
              mt: 4,
              p: { xs: 2.5, sm: 3 },
              borderRadius: 3,
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "white",
              backdropFilter: "blur(8px)",
            }}
          >
            <Stack spacing={2}>
              <Typography variant="h5" sx={{ fontWeight: 800 }}>
                Napredna podešavanja za biznise
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Zakazuj nudi potpunu kontrolu nad profilom radnje, terminima i
                pravilima zakazivanja, kako za timove tako i za pojedince.
              </Typography>
              <Grid container spacing={2}>
                {[
                  {
                    title: "Profil radnje i kontakt",
                    items: [
                      "Logo i naziv radnje",
                      "Opis, email, telefon i adresa",
                      "Link i QR kod za prijavu klijenata",
                    ],
                  },
                  {
                    title: "Radno vreme i neradni dani",
                    items: [
                      "Podesivo radno vreme po danima",
                      "Neradni dani i pauze",
                      "Termin se ne nudi kada je neradno",
                    ],
                  },
                  {
                    title: "Upravljanje zaposlenima",
                    items: [
                      "Dodavanje zaposlenih i uloga",
                      "Rasporedi po zaposlenima",
                      "Vidljivost termina po resursima",
                    ],
                  },
                  {
                    title: "Kontrola rezervacija",
                    items: [
                      "Obavezna potvrda termina",
                      "Otkazivanje i ponovno zakazivanje",
                      "Automatska obaveštenja klijentima",
                    ],
                  },
                ].map((block) => (
                  <Grid key={block.title} item xs={12} md={6}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2.5,
                        height: "100%",
                        borderRadius: 2.5,
                        background:
                          "linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)",
                        border: "1px solid rgba(255,255,255,0.08)",
                      }}
                    >
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {block.title}
                      </Typography>
                      <Stack spacing={1} sx={{ mt: 1 }}>
                        {block.items.map((item) => (
                          <Stack
                            key={item}
                            direction="row"
                            spacing={1}
                            alignItems="center"
                          >
                            <CheckCircleRoundedIcon fontSize="small" />
                            <Typography variant="body2">{item}</Typography>
                          </Stack>
                        ))}
                      </Stack>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Paper>

          {/* <MobileAppPromo
            googlePlayUrl="https://play.google.com/store/apps/details?id=com.zakazuj"
            appStoreUrl="https://apps.apple.com/app/id1234567890"
            apkUrl="" // ili npr. "/app/Zakazuj-1.0.0.apk"
            qrImage="/app/qr-zakazuj.png"
            phoneShot="/app/screen-1.png"
          /> */}

          <Paper
            elevation={0}
            sx={{
              mt: 4,
              p: { xs: 2.5, sm: 3 },
              borderRadius: 3,
              background:
                "linear-gradient(120deg, rgba(59,130,246,0.18) 0%, rgba(6,182,212,0.18) 100%)",
              border: "1px solid rgba(255,255,255,0.12)",
              color: "white",
              backdropFilter: "blur(8px)",
            }}
          >
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={7}>
                <Typography variant="h5" sx={{ fontWeight: 800 }}>
                  Preuzmite Zakazuj mobilnu aplikaciju
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, opacity: 0.9 }}>
                  Link za preuzimanje možete otvoriti direktno ili skenirati QR
                  kod koji dobijate od radnje. Aplikacija vas vodi kroz prijavu,
                  registraciju i zakazivanje u par koraka.
                </Typography>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  sx={{ mt: 2 }}
                >
                  <Link
                    href="https://apps.apple.com/app/id6754040503"
                    underline="none"
                    sx={{
                      px: 2.5,
                      py: 1,
                      borderRadius: 999,
                      fontWeight: 700,
                      color: "white",
                      border: "1px solid rgba(255,255,255,0.35)",
                      "&:hover": { background: "rgba(255,255,255,0.08)" },
                    }}
                  >
                    App Store
                  </Link>
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.stellar.zakazuj"
                    underline="none"
                    sx={{
                      px: 2.5,
                      py: 1,
                      borderRadius: 999,
                      fontWeight: 700,
                      color: "white",
                      border: "1px solid rgba(255,255,255,0.35)",
                      "&:hover": { background: "rgba(255,255,255,0.08)" },
                    }}
                  >
                    Google Play
                  </Link>
                </Stack>
              </Grid>
              <Grid item xs={12} md={5}>
                <Grid container spacing={2} justifyContent="center">
                  {[
                    { label: "App Store", src: QrAppStore },
                    { label: "Google Play", src: QrGooglePlay },
                  ].map((item) => (
                    <Grid item xs={6} sm={5} key={item.label}>
                      <Stack spacing={1} alignItems="center">
                        <Box
                          component="img"
                          src={item.src}
                          alt={item.label}
                          sx={{
                            width: "100%",
                            maxWidth: 160,
                            borderRadius: 2,
                            border: "1px solid rgba(255,255,255,0.25)",
                            background: "white",
                            p: 1,
                          }}
                        />
                        <Typography variant="caption" sx={{ opacity: 0.85 }}>
                          {item.label}
                        </Typography>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper
            elevation={0}
            sx={{
              mt: 5,
              p: { xs: 2.5, sm: 3 },
              borderRadius: 3,
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
              border: "1px solid rgba(255,255,255,0.1)",
              backdropFilter: "blur(8px)",
              color: "white",
            }}
          >
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <SupportAgentRoundedIcon />
                <Stack spacing={0.5}>
                  <Typography variant="h6" sx={{ fontWeight: 800 }}>
                    Potrebna vam je pomoć oko profila ili termina?
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.85 }}>
                    Za saradnju pišite na{" "}
                    <Link
                      href="mailto:system@zakazuj.com"
                      underline="none"
                      sx={{ color: "white", fontWeight: 700 }}
                    >
                      system@zakazuj.com
                    </Link>
                  </Typography>
                </Stack>
              </Stack>
              <Link
                component={RouterLink}
                to="/login"
                underline="none"
                sx={{
                  px: 2.5,
                  py: 1,
                  borderRadius: 999,
                  fontWeight: 700,
                  color: "white",
                  border: "1px solid rgba(255,255,255,0.25)",
                  "&:hover": { background: "rgba(255,255,255,0.08)" },
                }}
              >
                Prijavite se
              </Link>
            </Stack>
          </Paper>

          <Box
            sx={{
              pt: 4,
              pb: 2,
              textAlign: "center",
              color: "rgba(255,255,255,0.65)",
            }}
          >
            <Typography variant="caption">
              Zakazuj © {new Date().getFullYear()}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
